import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { CustomFacade, noWhitespaceValidator } from '@piqet-angular/data';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { CustomService } from 'libs/data/src/lib/services/custom/custom.service';
import { CustomModalService } from '@piqet-angular/shared';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { cloneDeep } from 'lodash';
import { GridCellDropdownComponent } from '../grid-cell-dropdown/grid-cell-dropdown.component';
import { setDelayedFlag } from 'libs/shared/src/lib/service/helper.service';
import { GridCellRendererComponent } from '../grid-cell-renderer/grid-cell-renderer.component';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { InlineActionButtonComponent } from '../inline-action-button/inline-action-button.component';
import { Subscription } from 'rxjs';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { CookieService } from 'ngx-cookie-service';
import { CustomFillingsDataGridService } from '@piqet-angular/features';

@Component({
  selector: 'piqet-angular-new-custom-filling',
  templateUrl: './new-custom-filling.component.html',
  styleUrls: ['./new-custom-filling.component.scss'],
})
export class NewCustomFillingComponent implements OnDestroy {
  fillingProcessList: any;
  customFillingForm!: FormGroup;
  fillingProcessForm: any;
  submitted = false;
  processSubmitted = false;
  isReadonly = true;
  processColumnDef: any;
  modalLabel: any;
  customData: any;
  params: any;
  @Output() saveCustomFillingEvent = new EventEmitter<{ payload: any; pathName: any }>();
  editDataList: any;
  isMaximize = false;
  energyItems: any;
  unitofProductItems: any;
  customFillingId = 0;
  ingredientId: any;
  fillingTypeId: any;
  ingredientIndex: any;
  headerBtn = 'Add row';
  headerBtnName = 'customFilling';
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  disableSubmit = false;
  errorNotification!: string;
  organizationlist: any;
  selectOrganization: any;
  activatedRoute: any;
  selectedDropDownValue: any;
  setOrganizationValue: any;
  fromEdit: any;
  organizationItems: any;
  gridLoaded = { value: false };
  showEdit: boolean = false;
  showCreate: boolean = false;
  showView: boolean = false;
  checkEntireAccess: boolean = false;
  frameworkComponents = {
    // actionRenderer: ActionButtonComponent,
    inlineActionButtonComponent: InlineActionButtonComponent,
    dropdownRendered: GridCellDropdownComponent,
    GridCellRendererComponent: GridCellRendererComponent,
  };
  isRowEditable = false;
  disableSubscription!: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    public customFacade: CustomFacade,
    private customService: CustomService,
    private modal: CustomModalService,
    private swalService: SwalService,
    private sharedService: SharedService,
    private cookieService: CookieService,
    private customFillingsDataGridService: CustomFillingsDataGridService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.processColumnDef = this.modal?.modalService?.config?.initialState?.['processColDef'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.customData = this.modal?.modalService?.config?.initialState?.['newCustomFillingData'];
    this.fromEdit = this.modal?.modalService?.config?.initialState?.['fromEdit'];
    this.isDisabledDropDown = this.modalLabel == 'Review custom filling' ? true : false;
    this.isHideDropDown = this.activatedRoute == 'adminCustomFilling' ? true : false;
    this.customFacade.fillingData$.subscribe((res: any) => {
      this.customData =
        (res.hasOwnProperty('length') && res.length) || (res && res.id) || !this.fromEdit
          ? res
          : this.customData;
      this.initializeData();
    });
  }

  ngOnInit(): void {
    // this.initializeData();
    this.showEdit = this.customFillingsDataGridService.isAccess(this.activatedRoute, 'edit');
    this.showCreate = this.customFillingsDataGridService.isAccess(this.activatedRoute, 'create');
    this.showView = this.customFillingsDataGridService.isAccess(this.activatedRoute, 'view');
    this.checkEntireAccess =
      (this.showCreate && !this.fromEdit) ||
      (this.fromEdit && this.showEdit) ||
      (this.fromEdit && !this.showView);
    this.disableSubscription = this.sharedService.disableAddRowBtnTrigger$.subscribe(
      (error: any) => {
        this.checkEditingStatus(error);
      }
    );
  }

  initializeData() {
    this.customFacade.customFillingenergyItems$.subscribe((response: any) => {
      this.energyItems = response;
    });
    this.customFacade.unitofProductItems$.subscribe((response: any) => {
      this.unitofProductItems = response;
    });
    this.customFacade.organizationItems$.subscribe((response: any) => {
      this.organizationItems = response;
    });
    this.organizationlist = this.customData.organizationItems;
    this.organizatioListFunction();
    this.customFillingId = this.customData.id;
    this.customFillingForm = this.formBuilder.group({
      fillingName: [this.customData.processName, [Validators.required, noWhitespaceValidator]],
      productName: [this.customData.unitofProductId || 2, [Validators.required]],
      organizationName: [null, Validators.required],
      fillingProcessForm: this.formBuilder.group({
        process: [null, Validators.required],
        amount: [null, Validators.required],
        cost: [0, [Validators.min(0)]],
        packageCost: [0, Validators.min(0)],
      }),
    });
    this.setFormData();
    this.selectedDropDownValue = this.selectOrganization;
    this.setOrganizationValue = this.selectOrganization;
    this.fillingProcessForm = this.customFillingForm.controls['fillingProcessForm'];
    this.customFacade.copiedFillingIngredient$.subscribe((ingredient: any) => {
      if (ingredient) {
        this.ingredientIndex = ingredient?.index;
        this.ingredientId = ingredient?.id;
        this.fillingTypeId = ingredient?.energyTypeId;
        this.customFillingForm.get('fillingProcessForm')?.patchValue({
          process: ingredient.energyName,
          amount: ingredient.amount,
          cost: ingredient.cost,
          packageCost: ingredient.packageCost,
        });
      }
    });
    this.customFacade.customFillingError$.subscribe((error: any) => {
      this.checkValidation(error);
    });
    setDelayedFlag(this.gridLoaded, true, 200);
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.customData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }
  setFormData() {
    this.customFillingForm.patchValue({ organizationName: this.selectOrganization });
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  onClose() {
    this.modal.close();
    // this.customFacade.clearFillingIngredient();
  }

  addFillingProcess() {
    this.processSubmitted = true;
    if (this.fillingProcessForm.controls['process'].valid) {
      this.fillingProcessForm.get('process')?.reset();
      this.processSubmitted = true;
      this.fillingProcessForm.controls['process'].markAsTouched();
      return;
    }
    if (this.fillingProcessForm.valid) {
      const processData = {
        energyName:
          this.fillingProcessForm.value.process.name || this.fillingProcessForm.value.process,
        amount: this.fillingProcessForm.value.amount,
        cost: this.fillingProcessForm.value.cost,
        packageCost: this.fillingProcessForm.getRawValue().packageCost,
        id: 0,
        energyTypeId: this.fillingProcessForm.value.process.id || this.fillingTypeId,
      };
      this.processSubmitted = false;
      this.customFacade.addfillingIngredientAction(processData, 'add');
      this.fillingProcessForm.reset();
    }
  }

  editFillingProcess() {
    this.processSubmitted = true;
    if (this.fillingProcessForm.controls['process'].valid) {
      this.fillingProcessForm.get('process')?.reset();
      this.processSubmitted = true;
      this.fillingProcessForm.controls['process'].markAsTouched();
      return;
    }
    if (this.fillingProcessForm.valid) {
      const processData = {
        energyName:
          this.fillingProcessForm.value.process.name || this.fillingProcessForm.value.process,
        amount: this.fillingProcessForm.value.amount,
        cost: this.fillingProcessForm.value.cost,
        packageCost: this.fillingProcessForm.getRawValue().packageCost,
        id: this.ingredientId || 0,
        energyTypeId: this.fillingProcessForm.value.process.id || this.fillingTypeId,
      };
      this.processSubmitted = false;
      this.customFacade.updatefillingIngredientAction(
        processData,
        'editIngredient',
        this.ingredientIndex
      );
      this.fillingProcessForm.reset();
    }
  }

  alertConfirmation(data: any) {
    this.swalService
      .confirm(
        'Are you sure?',
        'Are you sure you want to change the organization? if you are change the organization than energy process data will be lost.',
        'organization'
      )
      .then(confirmed => {
        if (confirmed) {
          this.setOrganizationValue = data;
          this.selectedDropDownValue = data;
        } else {
          this.setOrganizationValue = this.selectedDropDownValue;
        }
      });
  }

  selectValue(event: any) {
    if (event.name) {
      this.alertConfirmation(event);
    }
  }
  onSave(fillingProcessList: any) {
    this.submitted = true;
    this.processSubmitted = false;
    if (
      this.activatedRoute == 'adminCustomFilling' &&
      !this.customFillingForm.controls['organizationName'].value?.name &&
      !this.customFillingForm.controls['organizationName'].value
    ) {
      return;
    }
    if (this.customFillingForm.value.productName === 1) {
      if (
        this.customFillingForm.errors == null &&
        this.customFillingForm.controls['fillingName'].valid &&
        this.customFillingForm.controls['productName'].valid
      ) {
        const saveCustomFillingData: any = {
          id: this.customFillingId,
          processName: this.customFillingForm.value.fillingName.startsWith(' ')
            ? this.customFillingForm.value.fillingName.trimStart()
            : this.customFillingForm.value.fillingName,
          unitofProductId: this.customFillingForm.value.productName,
          organizationId:
            this.customFillingForm.controls['organizationName'].value?.id ||
            this.customData.organizationId ||
            this.cookieService.get('organizationId'),
          fillingProcessItems: fillingProcessList,
        };
        this.saveCustomFillingEvent.emit({
          payload: saveCustomFillingData,
          pathName: this.activatedRoute,
        });
        this.submitted = false;
      }
    } else {
      if (
        this.customFillingForm.errors == null &&
        this.customFillingForm.controls['fillingName'].valid &&
        this.customFillingForm.controls['productName'].valid
      ) {
        const saveCustomFillingData: any = {
          id: this.customFillingId,
          processName: this.customFillingForm.value.fillingName.startsWith(' ')
            ? this.customFillingForm.value.fillingName.trimStart()
            : this.customFillingForm.value.fillingName,
          unitofProductId: this.customFillingForm.value.productName,
          organizationId:
            this.customFillingForm.controls['organizationName'].value?.id ||
            this.customData.organizationId ||
            this.cookieService.get('organizationId'),
          fillingProcessItems: fillingProcessList,
        };
        this.saveCustomFillingEvent.emit({
          payload: saveCustomFillingData,
          pathName: this.activatedRoute,
        });
        this.submitted = false;
      }
    }
  }

  checkValidation(fillingProcessList: any): void {
    if (fillingProcessList) {
      this.disableSubmit = true;
    } else {
      this.disableSubmit = false;
    }
    this.processColumnDef = cloneDeep(this.processColumnDef);
    this.processColumnDef[0].cellEditorParams['fillingProcessList'] = this.energyItems;
  }

  inlineDataEditEvent(record: any) {
    if (record[2] === 'customFilling') {
      this.customService
        .GetPackageCostCalculationCustomFilling(record[1].amount, record[1].cost)
        .subscribe((data: any) => {
          this.customFacade.updateReuseIngredientAction(record[1], 'edit', record[3]);
        });
    }
  }

  manufactureCost() {
    const amount = this.customFillingForm.controls['fillingProcessForm'].value.amount;
    const cost = this.customFillingForm.controls['fillingProcessForm'].value.cost;
    this.customService
      .GetPackageCostCalculationCustomFilling(amount, cost)
      .subscribe((data: any) => {
        this.customFillingForm.controls['fillingProcessForm']
          .get('packageCost')
          ?.patchValue(data.data);
      });
  }
  checkEditingStatus(err: any) {
    // if any row in the grid is in edit mode then disable the add row button and save button
    if (err == 'editingStarted') {
      this.isRowEditable = true;
    } else if (err == 'editingStopped') {
      this.isRowEditable = false;
    }
  }

  ngOnDestroy() {
    this.customFacade.ClearCustomFiliingData();
    this.customFacade.clearfillingIngredientProces();
    this.disableSubscription.unsubscribe();
  }
}
